import { getUserTimeFormatEx } from "../../externalApi/DashboardHostApi";
// Expose user time APIs
export class WidgetLocaleTime {
    async getCurrentShortUserTime() {
        return await getUserTimeFormatEx();
    }
}
